import { Component, Input } from '@angular/core';

/**
 * Named item list for a donation — renders the canonical `donationItems` string
 * ("1 x Sofa (XL), 1 x Lamp (S)" — server-built, carries qty + size and is the source of truth
 * for the donation view, see phoneLeadWizard @CY-NPL-14). Shared by partner and non-Uber couriers
 * (RP-4182). Pass an empty `label` to show just the string inside a table.
 */
@Component({
  selector: 'rspl-donation-items',
  templateUrl: './donation-items.component.html',
})
export class DonationItemsComponent {
  @Input() donationItems?: string | null;
  @Input() label = 'Items Description:';
}
